import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandJobEngineInstanceStartPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandJobEngineInstanceStartProperties = {
    [name in keyof EntityCommandJobEngineInstanceStartPropertyValues]: Property<EntityCommandJobEngineInstanceStartPropertyValues[name]>
};

export interface IEntityCommandJobEngineInstanceStart extends IEntityCommand, EntityCommandJobEngineInstanceStartProperties
{
}

export class EntityCommandJobEngineInstanceStart extends EntityCommand implements IEntityCommandJobEngineInstanceStart
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandJobEngineInstanceStart";
    public static override className = "EntityCommandJobEngineInstanceStart";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandJobEngineInstanceStartPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Start",
                entityName: "JobEngineInstance",
                key: "START",
                permission: PermissionEvaluator.permissionLevels.execute,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandJobEngineInstanceStartPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    return (
                        ServiceManager.getRequired(WebApiClientService)
                            .createApiMethodRequest("DataService", "CallDataService", { id: "202c4702-7f0f-4b6a-aea9-1f2e959854e2", operation: "StartJobEngineInstance", data: ObjectHelper.toJson({ jobEngineInstanceId: recordId }) })
                            .executeAsync()
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

